/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Represents a Kubernetes taint to be applied to a node.
 * @export
 * @interface KubernetesTaint
 */
export interface KubernetesTaint {
    /**
     * The time at which the taint was added.
     * @type {string}
     * @memberof KubernetesTaint
     */
    'addTime'?: string;
    /**
     * The taint effect.
     * @type {string}
     * @memberof KubernetesTaint
     */
    'effect': KubernetesTaintEffectEnum;
    /**
     * The taint key.
     * @type {string}
     * @memberof KubernetesTaint
     */
    'key': string;
    /**
     * The taint value.
     * @type {string}
     * @memberof KubernetesTaint
     */
    'value'?: string;
}

export const KubernetesTaintEffectEnum = {
    TAINT_EFFECT_UNSPECIFIED: 'TAINT_EFFECT_UNSPECIFIED',
    NO_SCHEDULE: 'NO_SCHEDULE',
    PREFER_NO_SCHEDULE: 'PREFER_NO_SCHEDULE',
    NO_EXECUTE: 'NO_EXECUTE'
} as const;

export type KubernetesTaintEffectEnum = typeof KubernetesTaintEffectEnum[keyof typeof KubernetesTaintEffectEnum];


